
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/groups/[id]/[seriesID]",
      function () {
        return require("private-next-pages/learning/groups/[id]/[seriesID]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/groups/[id]/[seriesID]"])
      });
    }
  